import React, { useState, useEffect } from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionDark() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div id="our-mission" style={{
      background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
      padding: '120px 0',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      {/* Animated Background Elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 6s ease-in-out infinite'
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '15%',
        right: '8%',
        width: '150px',
        height: '150px',
        background: 'radial-gradient(circle, rgba(240, 147, 251, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 8s ease-in-out infinite 2s'
      }}></div>

      {/* Floating Icons */}
      <div style={{
        position: 'absolute',
        top: '20%',
        right: '10%',
        animation: 'bounce 3s infinite'
      }}>
        <i className="fa fa-rocket" style={{ 
          fontSize: '40px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite'
        }} />
      </div>
      
      <div style={{
        position: 'absolute',
        bottom: '25%',
        left: '8%',
        animation: 'bounce 3s infinite 1.5s'
      }}>
        <i className="fa fa-globe" style={{ 
          fontSize: '35px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite 1s'
        }} />
      </div>

      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="10">
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '30px',
              padding: '80px 60px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 30px 60px rgba(0,0,0,0.2)',
              position: 'relative',
              overflow: 'hidden',
              transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
              opacity: isVisible ? 1 : 0,
              transition: 'all 1s ease-out'
            }}>
              {/* Decorative Elements */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '100px',
                height: '100px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                borderRadius: '50%',
                opacity: 0.2
              }}></div>
              
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '-30px',
                width: '60px',
                height: '60px',
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                borderRadius: '50%',
                opacity: 0.2
              }}></div>

              <div style={{ position: 'relative', zIndex: 2 }}>
                <h2 style={{
                  color: 'white',
                  fontSize: '4rem',
                  fontWeight: '800',
                  marginBottom: '40px',
                  textShadow: '0 4px 8px rgba(0,0,0,0.3)',
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  🎯 Our Mission
                </h2>

                <div style={{
                  width: '120px',
                  height: '4px',
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  margin: '0 auto 50px',
                  borderRadius: '2px'
                }}></div>
                
                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '30px'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Being an <span style={{ color: '#feca57', fontWeight: '600' }}>innovative digital marketing solutions provider</span>, 
                    we aim to position Tri-Advise as one of the <span style={{ color: '#ff6b6b', fontWeight: '600' }}>Fintech leaders in the world</span>. 
                    We deliver the promise of the best possible digital innovative technologies.
                  </p>
                </div>

                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '30px'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Our devoted <span style={{ color: '#4facfe', fontWeight: '600' }}>agile multi-cultural teams</span> are always ready to go the extra mile 
                    in providing the best and the most reliable solutions. Tri-Advise is recognized 
                    for its <span style={{ color: '#feca57', fontWeight: '600' }}>in-house development</span> of customized state-of-the-art products and services.
                  </p>
                </div>

                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    We pledge to provide our customers, operators, business partners with <span style={{ color: '#ff6b6b', fontWeight: '600' }}>quality services</span> 
                    that will guarantee the optimal experience and return on investment. Tri-Advise is an <span style={{ color: '#4facfe', fontWeight: '600' }}>employer of choice</span>, 
                    conducting its business activities based on the best practices according to the international standards of corporate governance and business ethics.
                  </p>
                </div>

                {/* Mission Highlights */}
                <div style={{ 
                  display: 'flex', 
                  gap: '40px', 
                  marginTop: '60px',
                  flexWrap: 'wrap',
                  justifyContent: 'center'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#feca57',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>🚀</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Innovation</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#ff6b6b',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>🌍</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Global Leader</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#4facfe',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>💎</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Quality</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#f093fb',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>🤝</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Partnership</div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-15px); }
          60% { transform: translateY(-7px); }
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export default SectionDark;